export default __webpack_public_path__ + "static/media/buy-pizza.2f8f3c39.png";